import { Config } from '@zelostech/config';

export default class H5Config extends Config {
  static authClientId = 'bugs-ui';
  static authClientSecret = 'bugs-ui@123456';
  static authLogoutUrl = 'https://auth.zelostech.com.cn/logout';
}
